<template>
  <div class="auth-dialog-backdrop">
    <div class="auth-dialog" v-on-clickaway="hideDialog">
      <div class="top-button-container">
        <div @click="selectedTab = 0" :class="{ 'top-button-selected': loginSelected }">
          Sign In
        </div>
        <div @click="selectedTab = 1" :class="{ 'top-button-selected': signupSelected }">
          Sign Up
        </div>
      </div>
      <div v-if="loginSelected">
        <div class="login-welcome">Welcome to YouPaired</div>
      </div>
      <div v-else>
        <div class="login-welcome">Join YouPaired</div>
      </div>
      <div class="login-message" v-if="loginSelected">
        Discover Free Event Sponsorship Platform.
        <br>You are 30 seconds away!
      </div>
      <div class="login-message" v-else>
        Discover Free Event Sponsorship Platform.
         <br>You are 30 seconds away!
      </div>
      <div class="social-buttons">
        <font-awesome-icon
          :key="network.id"
          v-for="network in socialNetworks"
          :icon="['fab', network.icon]" size="3x"
          :class="`${network.id}-icon`" @click="authenticate(network.id)"/>
      </div>
      <div class="divider">
        <strong class="divider-or">or</strong>
      </div>
      <login-form v-if="loginSelected"></login-form>
      <signup-form v-else></signup-form>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { mapActions, mapMutations, mapState } from 'vuex';
import LoginForm from './LoginForm.vue';
import SignupForm from './SignupForm.vue';

export default {
  name: 'auth-dialog',
  mixins: [clickaway],
  components: {
    LoginForm,
    SignupForm,
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    ...mapState('auth', ['socialNetworks']),
    loginSelected() {
      return this.selectedTab === 0;
    },
    signupSelected() {
      return this.selectedTab === 1;
    },
  },
  methods: {
    ...mapActions('auth', ['authenticate']),
    ...mapMutations('auth', ['setAuthDialogVisibility']),
    hideDialog() {
      this.setAuthDialogVisibility(false);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.auth-dialog {
  text-align: center;
  // top: 10%;
  // left: 0;
  // right: 0;
  width: 100%;
  // margin-top: auto;
  margin: auto;
  max-width: 25rem;
  -webkit-font-smoothing: subpixel-antialiased;
  // transform: translateZ(0) scale(1.0, 1.0);
  max-height: 100%;
  overflow: scroll;
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
}

.auth-dialog-backdrop {
  // display: flex;
  // justify-content: center;
  // align-content: center;
  max-height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  z-index: 100;
}

.top-button-container {
  top: 0;
  display: flex;
  width: 100%;
  font-size: 1.3rem;
  cursor: pointer;
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  padding-bottom: 1rem;
}

.top-button-container > * {
  background-color: #E9EAEA;
  width: 50%;
}

.top-button-selected {
  background-color: white;
}

.social-buttons {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 0.5rem;
  margin: 0.75rem 0;
}

.social-buttons > * {
  padding: 0.5rem;
  cursor: pointer;
  &:hover {
    filter: brightness(0.2);
    -webkit-filter: brightness(0.2);
  }
}

.facebook-icon {
  color: $facebook;
}

.google-icon {
  color: $google;
}

.twitter-icon {
  color: $twitter;
}

.instagram-icon {
  color: $instagram;
}
.twitch-icon {
  color: $twitch;
}
.linkedin-icon {
  color: $linkedin;
}
.login-welcome{
  padding-top:0.5rem;
  font-size: 1.5rem;
}
.login-img{
  height: 6rem;
}

.login-message {
  font-size: 1rem;
  padding: 0.5rem;
  margin: 0.5rem 0;
}

.divider {
  border-top: 0.1rem solid $bottom-container;
  display: block;
  line-height: 0.1rem;
  margin: 0.75rem 0;
  // position: relative;
  text-align: center;
}

.divider-or {
  background: #fff;
  font-size: 0.875rem;
  letter-spacing: 0.1rem;
  padding: 0 0.875rem;
  text-transform: uppercase;
}

.account-message {
  font-size:0.875rem;
  padding: 0.5rem;
  margin: 0.5rem 0;
}

a {
  text-decoration: none;
}

.forgot-password {
  margin-top:1rem;
}

@media screen and (max-width: 823px) {
  .auth-dialog {
    width: 90%;
  }
}

@media screen and (min-height: 500px) {
  .auth-dialog-backdrop {
    display: flex;
  }

  .auth-dialog {
    align-self: center;
  }
}


</style>
